export interface WorkflowStep {
  step: string;
  inputProperties?: string[];
  models?: string[];
}

export interface StepGroup {
  label: string;
  steps: WorkflowStep[];
}

export interface Workflow {
  name: string;
  description: string;
  models: string[];
  requiredUserInput: string[];
  stepGroups: StepGroup[];
  n8nEndpoint?: string;
  n8nParameters?: string[];
}

export const workflows: Workflow[] = [
  {
    name: "Deal of the Week",
    description: "Lookup properties on Zillow and create a deal of the week.",
    models: ["openai"],
    requiredUserInput: ["location", "price", "property-type"],
    stepGroups: [
      {
        label: "Listing Leads",
        steps: [
          {
            step: "User input",
            inputProperties: ["location", "price", "property-type"],
          },
        ],
      },
      {
        label: "n8n",
        steps: [
          {
            step: "Zillow",
            models: ["rapid-api"],
          },
          {
            step: "Generate tokenized content",
            models: ["openai"],
          },
        ],
      },
      {
        label: "Listing Leads",
        steps: [
          {
            step: "Generate email",
            models: [],
          },
        ],
      },
    ],
  },
  {
    name: "Market Research",
    description:
      "Research properties on the market and create a market report.",
    models: ["perplexity", "openai"],
    requiredUserInput: ["location"],
    n8nEndpoint: "https://betteremail.app.n8n.cloud/webhook/research",
    n8nParameters: [
      "locations",
      "domains",
      "timeframe",
      "context",
      "subject",
      "previewText",
      "persona",
      "openaiPrompt",
      "perplexityModel",
      "perplexityTemperature",
      "openaiModel",
      "openaiTemperature",
      "brandkit",
      "schema",
    ],
    stepGroups: [
      {
        label: "Listing Leads",
        steps: [
          {
            step: "User input",
            inputProperties: ["location"],
          },
        ],
      },
      {
        label: "n8n",
        steps: [
          {
            step: "AI Research",
            models: ["perplexity"],
          },
          {
            step: "Generate tokenized content",
            models: ["openai"],
          },
        ],
      },
      {
        label: "Listing Leads",
        steps: [
          {
            step: "Generate email",
            models: [],
          },
        ],
      },
    ],
  },
  {
    name: "AI Writer",
    description:
      "Single step workflow. Uses AI to write the tokenized content for a given prompt.",
    models: ["openai"],
    requiredUserInput: [],
    stepGroups: [
      {
        label: "n8n",
        steps: [
          {
            step: "Generate tokenized content",
            models: ["openai"],
          },
        ],
      },
      {
        label: "Listing Leads",
        steps: [
          {
            step: "Generate email",
            models: [],
          },
        ],
      },
    ],
  },
  {
    name: "Simple Writer (no AI)",
    description:
      "Single step workflow. Does not use AI. Personalizes content directly from the customer's profile.",
    models: ["none"],
    requiredUserInput: [],
    stepGroups: [
      {
        label: "Listing Leads",
        steps: [
          {
            step: "Generate email",
            models: [],
          },
        ],
      },
    ],
  },
];

export const getWorkflow = (
  workflowName: string | null | undefined
): Workflow | undefined => {
  if (!workflowName) return undefined;
  return workflows.find((workflow) => workflow.name === workflowName);
};
